import React from 'react';

const FeatureList = ({ features, primaryColor, secondaryColor }) => {
	return (
		<ul role="list" className="pt-24 my-20 space-y-14 border-t border-gray-200">
			{features.map((feature, index) => (
				<li key={index} className="flex space-x-9">
					{/* Icon */}
					<svg
						className="flex-shrink-0 w-14 h-14"
						fill={primaryColor} // Set the fill color dynamically
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
							clipRule="evenodd"
						></path>
					</svg>
					<span className="text-base font-medium leading-tight" style={{ color: secondaryColor }}>
						{feature.label}
					</span>
				</li>
			))}
		</ul>
	);
};

const Feature = ({
	backgroundColor,
	primaryColor,
	secondaryColor,
	tertiaryColor,
	title,
	subTitle,
	features,
	footerTitle,
	imageUrl,
	title2,
	subTitle2,
	features2,
	footerTitle2,
	imageUrl2
}) => {
	return (
		<>
			<section style={{ backgroundColor: backgroundColor }}>
				<div className="py-24 px-12 mx-auto space-y-36 max-w-screen-xl md:space-y-60 sm:py-48 md:px-18">
					{/* Row  */}
					<div className="gap-24 items-center md:grid md:grid-cols-2 xl:gap-48">
						<div className="sm:text-lg" style={{ color: tertiaryColor }}>
							<h2
								className="mb-12 text-4xl tracking-tight font-extrabold"
								style={{ color: secondaryColor }}
							>
								{title}
							</h2>
							<p className="mb-24 font-light md:text-xl">{subTitle}</p>
							{/* <!-- List --> */}
							<FeatureList
								features={features}
								primaryColor={primaryColor}
								secondaryColor={secondaryColor}
							/>
							<p className="mb-24 font-light md:text-xl">{footerTitle}</p>
						</div>
						<img
							className="hidden mb-12 w-full md:mb-0 md:flex rounded-lg"
							src={imageUrl}
							alt="office feature image"
						/>
					</div>
					{/* <!-- Row --> */}
					<div className="gap-24 items-center md:grid md:grid-cols-2 xl:gap-48">
						<img
							className="hidden mb-12 w-full md:mb-0 md:flex rounded-lg"
							src={imageUrl2}
							alt="office feature image 2"
						/>
						<div className="sm:text-lg" style={{ color: tertiaryColor }}>
							<h2
								className="mb-12 text-4xl tracking-tight font-extrabold"
								style={{ color: secondaryColor }}
							>
								{title2}
							</h2>
							<p className="mb-24 font-light md:text-xl">{subTitle2}</p>
							{/* <!-- List --> */}
							<FeatureList
								features={features2}
								primaryColor={primaryColor}
								secondaryColor={secondaryColor}
							/>
							<p className="font-light md:text-xl">{footerTitle2}</p>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Feature;
